class PrescriptionGlassesStepper extends HTMLElement {
  constructor() {
    super()

    // Elements
    this.stepIndicatorCurrentEl = this.querySelector('[data-step-indicator-current]')
    this.form = this.querySelector('[data-stepper-form]')
    this.stepIndicatorTotalEl = this.querySelector('[data-step-indicator-total]')
    this.stepProgressBarEl = this.querySelector('[data-step-progress-bar]')
    this.stepBackBtn = this.querySelector('[data-step-back]')
    this.closeBtn = this.querySelector('[data-step-close]')
    this.stepEls = this.querySelectorAll('[data-step]')
    this.stepRadios = this.querySelectorAll('[data-step-radio]')
    this.stepperContentEl = this.querySelector('[data-stepper-content]')
    this.savedSubscriptionBtns = this.querySelectorAll('[data-saved-prescription-button]')
    this.newSubscriptionBtns = this.querySelectorAll('[data-new-prescription-button]')
    this.prescriptionSaveAndContinueBtn = this.querySelector('[data-prescription-save-and-continue]')
    this.prescriptionSaveAndFinishBtn = this.querySelector('[data-prescription-save-and-finish]')
    this.prescriptionStepEnter = this.querySelector('[data-prescription-step-enter]')
    this.prescriptionStepUpload = this.querySelector('[data-prescription-step-upload]')
    this.productTotalEl = this.querySelector('[data-product-total]')
    this.atcBtn = this.querySelector('[data-atc-button]')
    this.prescriptionSelector = this.querySelector('prescription-selector')
    this.productSelect = document.querySelector('[data-product-select]')
    this.optionInputWrappers = this.querySelectorAll('[data-option-input-wrapper]')
    this.lensJson = JSON.parse(this.querySelector('[data-lens-json]').innerHTML)

    // Summary/Selection Elements
    this.summaryFramePrice = this.querySelector('[data-summary-frame-price]')
    this.summaryLensTotalPrice = this.querySelector('[data-summary-lens-total-price]')
    this.summaryLensTypeTitles = this.querySelectorAll('[data-summary-lens-type-title]')
    this.summaryLensTypePrices = this.querySelectorAll('[data-summary-lens-type-price]')
    this.summaryLensSunglassesTitles = this.querySelectorAll('[data-summary-lens-sunglasses-title]')
    this.summaryLensSunglassesPrices = this.querySelectorAll('[data-summary-lens-sunglasses-price]')
    this.summaryLensMaterialTitles = this.querySelectorAll('[data-summary-lens-material-title]')
    this.summaryLensMaterialPrices = this.querySelectorAll('[data-summary-lens-material-price]')
    this.summaryLensPerformanceTitles = this.querySelectorAll('[data-summary-lens-performance-title]')
    this.summaryLensPerformancePrices = this.querySelectorAll('[data-summary-lens-performance-price]')
    this.summaryLensExperienceTitles = this.querySelectorAll('[data-summary-lens-experience-title]')
    this.summaryLensExperiencePrices = this.querySelectorAll('[data-summary-lens-experience-price]')
    this.selectionLensTypeRow = this.querySelector('[data-selection-type-row]')
    this.selectionLensSunglassesRow = this.querySelector('[data-selection-sunglasses-row]')
    this.selectionLensMaterialRow = this.querySelector('[data-selection-material-row]')
    this.selectionLensPerformanceRow = this.querySelector('[data-selection-performance-row]')
    this.selectionLensExperienceRow = this.querySelector('[data-selection-experience-row]')
    this.selectionEditButtons = this.querySelectorAll('[data-selection-edit]')
    this.selectionEl = this.querySelector('[data-selection]')
    this.selectionToggles = this.querySelectorAll('[data-selection-toggle]')
    this.selectionTable = this.querySelector('[data-selection-table]')

    // Page Elements
    this.productSection = this.closest('product-section')
    this.gallery = this.productSection.querySelector('[data-product-gallery-wrapper]')
    this.formWrapper = this.productSection.querySelector('[data-product-form-wrapper]')

    // Data
    this.currentStep = parseInt(this.stepIndicatorCurrentEl.dataset.stepIndicatorCurrent, 10)
    this.totalSteps = parseInt(this.stepIndicatorTotalEl.dataset.stepIndicatorTotal, 10)
    this.savedPrescriptionSelected = false
    this.formType = ''

    this.initializeStepper()
  }

  initializeStepper () {
    try {
      this.setStepNumber(this.currentStep)
      this.initScrollable()
      this.radioListeners()
      this.backBtnListener()
      this.closeBtnListener()
      this.atcInit()
      this.initEditButtons()
      this.initSelectionToggles()
    } catch (error) {
      console.error('Error: something went wrong with the PrescriptionGlassesStepper element', error)
    }
  }

  setStepNumber (number, override = false) {
    this.scrollToForm()
    let stepNumber = number
    if (
      this.currentStepEl &&
      this.currentStepEl.nodeName === 'PRESCRIPTION-SELECTOR' &&
      this.currentStepEl.currentStep > 1 &&
      this.currentStep > stepNumber &&
      stepNumber > 1 &&
      !override
    ) {
      this.currentStepEl.changeStep(-1)
      return
    }
    if (stepNumber < 1) { return }

    if (this.savedPrescriptionSelected && this.currentStep === this.totalSteps) {
      stepNumber = stepNumber - 1
    }

    let activeStepEl = this.querySelector(`[data-step="${stepNumber}"]`)
    if (activeStepEl.nodeName === 'PRESCRIPTION-SELECTOR' && this.formType === 'No RX needed') {
      // Skip RX Form if no RX is needed
      stepNumber = this.currentStep < stepNumber ? stepNumber + 1 : stepNumber - 1
      activeStepEl = this.querySelector(`[data-step="${stepNumber}"]`)
    }

    const stepProgressPercentage = stepNumber / this.totalSteps * 100

    this.stepIndicatorCurrentEl.innerHTML = stepNumber
    this.stepProgressBarEl.style.width = `${stepProgressPercentage}%`
    this.stepBackBtn.toggleAttribute('disabled', stepNumber <= 1)
    this.atcBtn.classList.toggle('active', stepNumber >= this.totalSteps)
    this.stepperContentEl.scrollTop = 0

    this.stepEls.forEach((stepEl) => { stepEl.classList.remove('active') })
    activeStepEl.classList.add('active')

    this.currentStepEl = activeStepEl
    this.currentStep = stepNumber

    this.classList.toggle('scrollable', activeStepEl.offsetHeight > this.stepperContentEl.offsetHeight)
  }

  initScrollable () {
    this.stepperContentEl.addEventListener('scroll', () => {
      this.classList.remove('scrollable')
    })
  }

  radioListeners () {
    this.stepRadios.forEach((stepRadio) => {
      stepRadio.addEventListener('click', () => {
        this.setStepNumber(this.currentStep + 1)
        this.updateStepperData(stepRadio)
        this.scrollToForm()
      })
    })
  }

  updateStepperData (input) {
    this.updateTotal()

    if (input && input.hasAttribute('data-product-input')) {
      this.updateOptionInputs(input.value)
    }

    if (input && input.hasAttribute('data-rx-form')) {
      this.formType = input.dataset.rxForm
      this.prescriptionSelector.updateFormBasedOnLens(input.dataset.rxForm)
    }
  }

  updateTotal () {
    // Base Product
    const selectedProductOption = [...this.productSelect.querySelectorAll('option')].find(option => option.value === this.productSelect.value)
    const productPrice = Number(selectedProductOption?.dataset.price)
    this.summaryFramePrice.innerHTML = this.createPrice(productPrice)

    // Lens Type
    const selectedLensType = this.querySelector('input[name="lens_type"]:checked')
    const selectedLensTypePrice = selectedLensType ? Number(selectedLensType.dataset.price) : 0
    this.selectionLensTypeRow && this.selectionLensTypeRow.classList.toggle('hidden', !selectedLensType)
    this.summaryLensTypeTitles.forEach(summaryLensTypeTitle => { summaryLensTypeTitle.innerHTML = selectedLensType ? selectedLensType.dataset.label : '' })
    this.summaryLensTypePrices.forEach(summaryLensTypePrice => { summaryLensTypePrice.innerHTML = this.createPrice(selectedLensTypePrice) })

    // Lens Treatment
    const selectedLensTreatment = this.querySelector('input[name="treatment"]:checked')
    const selectedLensTreatmentPrice = selectedLensTreatment ? Number(selectedLensTreatment.dataset.price) : 0
    this.selectionLensSunglassesRow && this.selectionLensSunglassesRow.classList.toggle('hidden', !selectedLensTreatment)
    this.summaryLensSunglassesTitles.forEach(summaryLensSunglassesTitle => { summaryLensSunglassesTitle.innerHTML = selectedLensTreatment ? selectedLensTreatment.dataset.label : '' })
    this.summaryLensSunglassesPrices.forEach(summaryLensSunglassesPrice => { summaryLensSunglassesPrice.innerHTML = this.createPrice(selectedLensTreatmentPrice) })

    // Lens Material
    const selectedLensMaterial = this.querySelector('input[name="material"]:checked')
    const selectedLensMaterialPrice = selectedLensMaterial ? Number(selectedLensMaterial.dataset.price) : 0
    this.selectionLensMaterialRow && this.selectionLensMaterialRow.classList.toggle('hidden', !selectedLensMaterial)
    this.summaryLensMaterialTitles.forEach(summaryLensMaterialTitle => { summaryLensMaterialTitle.innerHTML = selectedLensMaterial ? selectedLensMaterial.dataset.label : '' })
    this.summaryLensMaterialPrices.forEach(summaryLensMaterialPrice => { summaryLensMaterialPrice.innerHTML = this.createPrice(selectedLensMaterialPrice) })

    // Lens Coating Add-on
    const selectedLensCoating = this.querySelector('input[name="lens_coating"]:checked')
    const selectedLensCoatingPrice = selectedLensCoating ? Number(selectedLensCoating.dataset.price) : 0
    this.selectionLensPerformanceRow && this.selectionLensPerformanceRow.classList.toggle('hidden', !selectedLensCoating)
    this.summaryLensPerformanceTitles.forEach(summaryLensPerformanceTitle => { summaryLensPerformanceTitle.innerHTML = selectedLensCoating ? selectedLensCoating.dataset.label : '' })
    this.summaryLensPerformancePrices.forEach(summaryLensPerformancePrice => { summaryLensPerformancePrice.innerHTML = this.createPrice(selectedLensCoatingPrice) })

    // Lens Desgin
    const selectedLensDesign = this.querySelector('input[name="design"]:checked')
    const selectedLensDesignPrice = selectedLensDesign ? Number(selectedLensDesign.dataset.price) : 0
    this.selectionLensExperienceRow && this.selectionLensExperienceRow.classList.toggle('hidden', !selectedLensDesign)
    this.summaryLensExperienceTitles.forEach(summaryLensExperienceTitle => { summaryLensExperienceTitle.innerHTML = selectedLensDesign ? selectedLensDesign.dataset.label : '' })
    this.summaryLensExperiencePrices.forEach(summaryLensExperiencePrice => { summaryLensExperiencePrice.innerHTML = this.createPrice(selectedLensDesignPrice) })

    // Hide Selection if no selections
    const hasSelection = Boolean(
      selectedLensType ||
      selectedLensTreatment ||
      selectedLensMaterial ||
      selectedLensCoating ||
      selectedLensDesign
    )
    this.selectionEl.classList.toggle('hidden', !hasSelection)
    this.selectionToggles.forEach(selectionToggle => {
      selectionToggle.disabled = !hasSelection
    })

    // Lens Total
    const lensTotalPrice = selectedLensTypePrice + selectedLensCoatingPrice + selectedLensTreatmentPrice + selectedLensMaterialPrice + selectedLensDesignPrice
    this.summaryLensTotalPrice.innerHTML = this.createPrice(lensTotalPrice)

    // Update Bottom Total
    const totalPrice = productPrice + lensTotalPrice
    this.productTotalEl.innerHTML = this.createPrice(totalPrice)
  }

  createPrice (price) {
    if (price === 0 || price === window.theme.strings.included) return window.theme.strings.included
    return `$${(price * 0.01).toFixed(2)}`
  }

  updateOptionInputs (handle) {
    this.optionInputWrappers.forEach(optionInputWrapper => {
      optionInputWrapper.classList.toggle('hidden', optionInputWrapper.dataset.for !== handle)
      if (!optionInputWrapper.classList.contains('hidden')) { return }

      const inputs = optionInputWrapper.querySelectorAll('input')
      inputs.forEach(input => {
        input.checked = false
      })
    });
  }

  backBtnListener () {
    if (!this.stepBackBtn) { return }

    this.stepBackBtn.addEventListener('click', (event) => {
      event.preventDefault()

      this.setStepNumber(this.currentStep - 1)
      this.scrollToForm()
    })
  }

  closeBtnListener () {
    this.closeBtn && this.closeBtn.addEventListener('click', () => { this.close() })
  }

  /**
   * Gets encrypted Rx data
   * @param {*} plainText
   * @param {*} key
   * @returns Encrypted message
   */
  async getEncryptedText(plainText) {
    const apiUrl = `${window.apiUrl}/guest/encryptMessage`
    const token = localStorage.getItem('LRTokenKey')    
    if (!token) {
      return false
    }
    const reqBody = JSON.stringify({
      'message': plainText
    })
    const fetchOptions = {
      method: 'POST',
      headers: {        
        'Authorization': `Bearer ${token}`,
        'Content-Type': "application/json"
      },
      body: reqBody
    }
    const data = await fetch(apiUrl, fetchOptions)
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok')
        }
        return response.json()
      })
      .then(data => {
        return data
      })
      .catch(error => {
        console.error('There was a problem with the fetch operation:', error)
      })
    return data
  } 

  /**
   * Add to cart btn click event
   */
  atcInit () {
    this.atcBtn.addEventListener('click', (event) => {
      event.preventDefault()
      this.atcBtn.disabled = true
      const frameId = Number(this.productSelect.value)
      const selectedPrescription = this.querySelector('input[name="prescription"]:checked')
      const prescriptionId = selectedPrescription.value
      const nearAdd = selectedPrescription.dataset.nearAdd
      const data = {
        items: []
      }
      const frameGroupId = Date.now()
      const selectedCoating = this.querySelector('input[name="lens_coating"]:checked')
      if (selectedCoating) {
        const coatingId = Number(selectedCoating.value)
        const coatingItem = {
          id: coatingId,
          quantity: 1,
          properties: {
            _frame_group_id: frameGroupId,
            associated_frame: localStorage.getItem("variantUPC"),
            nearVisionLenses: nearAdd,
            prescriptionID: prescriptionId
          }
        }
        data.items.push(coatingItem)
      }
      const lensVariant = this.findCorrectLensId()
      if (lensVariant) {
        const lensItem = {
          id: lensVariant.id,
          quantity: 1,
          properties: {
            _frame_group_id: frameGroupId,
            associated_frame: localStorage.getItem("variantUPC"),
            nearVisionLenses: nearAdd,
            prescriptionID: prescriptionId
          }
        }
        data.items.push(lensItem)
      }
      const frameItem = {
        id: frameId,
        quantity: 1,
        properties: {
          _frame_group_id: frameGroupId,
          prescriptionID: prescriptionId,
          nearVisionLenses: nearAdd,
          ...(lensVariant) && { related_lens: lensVariant.id },
          ...(selectedCoating) && { related_coating: Number(selectedCoating.value) }
        }
      }
      data.items.push(frameItem)
      data.items.reverse()     
      
      const cartNotification = document.querySelector('cart-notification')
      cartNotification.setActiveElement(document.activeElement)
      data.sections = cartNotification.getSectionsToRender().map((section) => section.id)
      data.sections_url = window.location.pathname
      
      if (window.cartPrescriptions.prescriptions) {
        fetch(`${window.theme.cart.cart_add_url}.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(data)
        }).then((response) => {
          if (!response.ok) {
            return response.json().then((errorData) => {
              throw errorData
            })
          }
          return response.json()
        }).then((result) => {
          if (result.status) {
            throw new Error(result.description)
          }
          cartNotification.renderContents(result)
          this.atcBtn.disabled = false
          setTimeout(() => {
            const modalDialog = document.querySelector('modal-dialog')
            modalDialog.removeAttribute('open')
            document.body.classList.remove('overflow-hidden')
            document.getElementById('cart-notification')?.classList.add('active')
          }, 1000)
          return null
        }).catch((error) => {
          console.error(error)
        })
      } else {
        fetch(`${window.theme.cart.cart_add_url}.js`, {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'xmlhttprequest'
          },
          body: JSON.stringify(data)
        }).then((response) => {
          if (!response.ok) {
            return response.json().then((errorData) => {
              throw errorData
            })
          }
          return response.json()
        }).then((result) => {
          if (result.status) {
            throw new Error(result.description)
          }
          cartNotification.renderContents(result)
          this.atcBtn.disabled = false
          setTimeout(() => {
            const modalDialog = document.querySelector('modal-dialog')
            modalDialog.removeAttribute('open')
            document.body.classList.remove('overflow-hidden')
            document.getElementById('cart-notification')?.classList.add('active')
          }, 1000)
          return null
        }).catch((error) => {
          console.error(error)
        })
      }
    })
  }

  findCorrectLensId () {
    const selectedLensType = this.querySelector('input[name="lens_type"]:checked').value
    const selectedLensTreatment = this.querySelector('input[name="treatment"]:checked').value
    const selectedLensMaterial = this.querySelector('input[name="material"]:checked').value
    const selectedLensDesign = this.querySelector('input[name="design"]:checked').value
    const optionsArray = [selectedLensTreatment, selectedLensMaterial, selectedLensDesign]

    return this.lensJson[selectedLensType].find((variant) => {
      return variant.options.every(option => optionsArray.includes(option))
    })
  }

  initEditButtons () {
    this.selectionEditButtons.forEach(selectionEditButton => {
      selectionEditButton.addEventListener('click', () => {
        const stepNumber = Number(selectionEditButton.dataset.step)
        this.setStepNumber(stepNumber, true)
        this.scrollToForm()
      })
    });
  }

  initSelectionToggles () {
    this.selectionToggles.forEach(selectionToggle => {
      selectionToggle.addEventListener('click', () => { this.toggleSelection() })
    })
  }

  toggleSelection () {
    this.selectionToggles.forEach(selectionToggle => {
      selectionToggle.ariaExpanded = selectionToggle.ariaExpanded === 'false' ? 'true' : 'false'
    })

    this.selectionTable.classList.toggle('active')
  }

  open () {
    this.updateTotal()
    this.gallery.classList.add('large-down-hide')
    this.formWrapper.classList.add('hidden')
    this.classList.remove('hidden')
    this.scrollToForm()
  }

  close () {
    this.gallery.classList.remove('large-down-hide')
    this.formWrapper.classList.remove('hidden')
    this.classList.add('hidden')
  }

  scrollToForm () {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }
}

customElements.define('prescription-glasses-stepper', PrescriptionGlassesStepper)
